"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowRadioEdit = /** @class */ (function (_super) {
    __extends(CardRowRadioEdit, _super);
    function CardRowRadioEdit(props, context) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" };
        return _this;
    }
    CardRowRadioEdit.prototype.onSelectionChange = function (e) {
        if ((e.target.value)) {
            if (this.props.onValueChanged) {
                this.props.onValueChanged(e.target.value);
            }
        }
    };
    CardRowRadioEdit.prototype.getRadioButtons = function () {
        var _ret = [];
        for (var i = 0; i < this.props.items.length; i++) {
            _ret.push(React.createElement(antd_1.Radio.Button, { key: this.props.items[i].key, value: this.props.items[i].key }, this.props.items[i].title));
        }
        return _ret;
    };
    CardRowRadioEdit.prototype.getRenderObject = function () {
        if (this.props.value) {
            return (React.createElement(antd_1.Radio.Group, { style: { marginLeft: "5px" }, disabled: this.props.disabled, defaultValue: this.props.value, onChange: this.onSelectionChange.bind(this), buttonStyle: "solid" }, this.getRadioButtons()));
        }
        else {
            return (React.createElement(antd_1.Radio.Group, { style: { marginLeft: "5px" }, disabled: this.props.disabled, onChange: this.onSelectionChange.bind(this), buttonStyle: "solid" }, this.getRadioButtons()));
        }
    };
    CardRowRadioEdit.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            React.createElement("div", { style: { display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" } },
                React.createElement("div", { style: {
                        width: "224px",
                        height: "32px",
                        color: "rgba(0,0,0,.65)",
                        textAlign: "center",
                        borderTopLeftRadius: "4px",
                        borderBottomLeftRadius: "4px",
                        backgroundColor: "#fafafa",
                        borderWidth: "1px",
                        borderStyle: "solid",
                        borderColor: "#d9d9d9",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "31px"
                    } }, this.props.title),
                this.getRenderObject())));
    };
    return CardRowRadioEdit;
}(React.Component));
exports.default = CardRowRadioEdit;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowRadioEdit.tsx
// module id = 308
// module chunks = 0